import { PlusPanelItemDef } from './MessageType';

export const PLUS_PANEL_ITEMS: PlusPanelItemDef[] = [
  { key: 'image', label: '图片', supportedOnWeb: true, order: 1 },
  { key: 'camera', label: '拍摄', supportedOnWeb: false, order: 3 },
  { key: 'quickContract', label: '闪电合约', supportedOnWeb: false, order: 4 },
  { key: 'order', label: '发送订单', supportedOnWeb: false, order: 5 },
  { key: 'product', label: '发送商品', supportedOnWeb: false, order: 6 },
];
